// Datos ficticios de ejemplo — plantilla "Esencial" (casamiento civil íntimo).

export const datosEjemplo = {
  tipoEvento: "civil",
  plantillaId: "civil-esencial",

  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "La cuenta regresiva", titulo: "Nos vemos en", textoFinalizado: "¡Hoy es el día!" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "El día", titulo: "Ceremonia y brindis" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agendalo", titulo: "Reservá la fecha" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Nosotros", titulo: "Pequeña historia" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "El plan", titulo: "Así será el día" },
    { id: "menciones", visible: true, orden: 6, etiqueta: "Testigos", titulo: "Nuestros testigos" },
    { id: "video", visible: false, orden: 7, etiqueta: "Video", titulo: "Nuestro video" },
    { id: "musica", visible: true, orden: 8, etiqueta: "La banda sonora", titulo: "Nuestras canciones" },
    { id: "rsvp", visible: true, orden: 9, etiqueta: "Confirmación", titulo: "Confirmá tu asistencia" },
    { id: "enlaces", visible: true, orden: 10, etiqueta: "Datos útiles", titulo: "Información adicional" },
    { id: "accesos", visible: true, orden: 11, etiqueta: "Participá", titulo: "Dejá tu huella" },
    { id: "cierre", visible: true, orden: 12 },
  ],

  pareja: {
    nombre1: "Carolina",
    nombre2: "Diego",
    fraseIntroductoria: "Nos casamos, en familia",
    mensajePortada:
      "Celebramos nuestra unión civil en un almuerzo íntimo con las personas más cercanas.",
    mensajeCierre:
      "Gracias por estar en lo simple y verdadero. Los esperamos.",
  },

  evento: {
    fechaISO: "2027-03-27T11:00:00-03:00",
    fechaLegible: "Sábado 27 de marzo de 2027",
    fechaCorta: "27 · 03 · 2027",
    ciudad: "Asunción, Paraguay",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1522673607200-164d1b6ce486?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Carolina y Diego de la mano",
      },
      {
        src: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "La pareja caminando",
      },
      {
        src: "https://images.unsplash.com/photo-1520854221256-17451cc331bf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Detalle del ramo",
      },
      {
        src: "https://images.unsplash.com/photo-1529634806980-85c3dd6d34ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Brindis íntimo",
      },
    ],
  },

  eventos: [
    {
      id: "ceremonia",
      etiqueta: "Ceremonia civil",
      lugar: "Registro Civil Central",
      direccion: "Chile esq. Manduvirá, Asunción",
      horario: "11:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Registro+Civil+Asunci%C3%B3n",
      textoBoton: "Cómo llegar",
    },
    {
      id: "brindis",
      etiqueta: "Almuerzo íntimo",
      lugar: "Restaurante La Terraza",
      direccion: "Av. Aviadores del Chaco 1050, Asunción",
      horario: "13:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Aviadores+del+Chaco+Asunci%C3%B3n",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "Boda civil de Carolina & Diego",
    descripcion: "Ceremonia 11:00 h en Registro Civil y almuerzo 13:00 h en Restaurante La Terraza.",
    texto: "Sábado 27 de marzo de 2027 · Asunción, Paraguay. Guardá la fecha.",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2027-03-27T11:00:00-03:00",
    finISO: "2027-03-27T16:00:00-03:00",
    ubicacion: "Registro Civil Central, Asunción, Paraguay",
  },

  itinerario: [
    { hora: "10:30", titulo: "Llegada", descripcion: "Recepción de invitados en el Registro.", icono: "reloj" },
    { hora: "11:00", titulo: "Ceremonia", descripcion: "Firma y votos civiles.", icono: "anillos" },
    { hora: "12:00", titulo: "Fotos", descripcion: "Retratos con la familia.", icono: "camara" },
    { hora: "13:00", titulo: "Almuerzo", descripcion: "Brindis y almuerzo íntimo.", icono: "copas" },
    { hora: "15:30", titulo: "Cierre", descripcion: "Café y despedida.", icono: "corazon" },
  ],

  menciones: [
    {
      nombre: "Laura Giménez",
      rol: "Testigo de la novia",
      foto: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Marcos Duarte",
      rol: "Testigo del novio",
      foto: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
  ],

  video: {
    urlYoutube: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },

  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    nota: "Dale play cuando quieras. La música nunca arranca sola.",
  },

  rsvp: {
    mensaje:
      "Es un almuerzo íntimo con lugares contados. Confirmá tu asistencia para guardarte el tuyo.",
    textoBoton: "Confirmar asistencia",
    fechaLimite: "Por favor confirmá antes del 27 de febrero de 2027",
  },

  enlaces: [
    { texto: "Dress code: casual elegante", url: "https://www.pinterest.com" },
    { texto: "#CaroYDiego2027", url: "https://www.instagram.com" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Libro de firmas",
      texto: "Dejanos unas palabras para recordar.",
    },
    album: {
      titulo: "Álbum colaborativo",
      texto: "Sumá tus fotos del día.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Hecho con amor · Pro360 Invitaciones Digitales Plus",
  },
};
